import { useQuery } from '@tanstack/react-query';
import { getApiBaseUrl } from '@/lib/api-base-url';
import { authFetch } from '@/lib/auth-fetch';

type DecimalString = string | null;

export interface QpAlignmentRow {
  hedgeRequestId: string | null;
  orderId: string | null;
  ticketId: number | null;
  hedgeMetal: string | null;
  executionId: string | null;
  executionType: string | null;
  direction: string | null;
  quantityMt: DecimalString;
  promptDate: string | null;
  promptMonth: string | null;
  alignmentStatus: string | null;
  targetPromptMonth: string | null;
  daysToPrompt: number | null;
  resolvedQpEnd: string | null;
  resolvedQpMonth: string | null;
}

export class HedgingQpAlignmentApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
    this.name = 'HedgingQpAlignmentApiError';
  }
}

async function fetchQpAlignment(metal: string | null): Promise<QpAlignmentRow[]> {
  const url = new URL(`${getApiBaseUrl()}/hedging/qp-alignment`);
  if (metal) url.searchParams.set('metal', metal);
  const response = await authFetch(url.toString());
  if (!response.ok) {
    throw new HedgingQpAlignmentApiError(
      `Request failed (${String(response.status)})`,
      response.status,
    );
  }
  return (await response.json()) as QpAlignmentRow[];
}

export const HEDGING_QP_ALIGNMENT_QUERY_KEY = ['hedging', 'qp-alignment'] as const;

export function useHedgingQpAlignment(metal: string | null = null) {
  return useQuery({
    queryKey: [...HEDGING_QP_ALIGNMENT_QUERY_KEY, metal],
    queryFn: () => fetchQpAlignment(metal),
  });
}
